/*
 * @Descripttion:订单下载支付详情 下载回单
 * @Date: 2025-09-19 10:12:42
 */
import { formatter } from '@/utils';
import { download } from 'xrk-tools';
import {
  batchOrderPayDetailExport,
  orderPayDetailExport,
  batchDownloadReceipt,
  supplierBatchDownload,
  orderPayDetailExportSupplier,
  batchOrderPayDetailExportSupplier
} from '../../data-source/order/apis';
import { BaseRadio, BaseRadioGroup, createDialog } from 'xrk-components';
import { ref } from 'vue';

/**
 * 单条下载回单
 * @param receiptUrl
 */
export const downLoadReceipt = receiptUrl => {
  const fileName = `电子回单_${formatter.date(Date.now(), 'YYYYMMDD')}`;
  download.downloadFile(receiptUrl, {
    fileName: decodeURIComponent(fileName),
    useResponseFileName: false
  });
};

/**
 * 单条下载支付详情
 * @param payPassagewayCode  支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
 * @param aspOrderIdList  项目服务费订单ID集合
 */
export const downLoadOrderPayDetail = async ({
  payPassagewayCode,
  aspOrderIdList
}) => {
  await orderPayDetailExport({ payPassagewayCode, aspOrderIdList });
};

/**
 * 批量下载支付详情
 * @param payPassagewayCode  支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
 * @param aspOrderIdList  项目服务费订单ID集合
 */
export const batchDownLoadOrderPayDetail = async ({
  payPassagewayCode,
  aspOrderIdList
}) => {
  const downLoadType = ref(1);
  createDialog({
    width: 300,
    title: '批量下载支付详情',
    showClose: true,
    contentRender: () => {
      return (
        <>
          <div style="padding:20px">
            <BaseRadioGroup v-model={downLoadType.value}>
              <BaseRadio value={1}>汇总一个表格</BaseRadio>
              <BaseRadio style="margin-top:20px" value={2}>
                汇总多个表格
              </BaseRadio>
            </BaseRadioGroup>
          </div>
        </>
      );
    },
    beforeConfirm: async done => {
      await batchOrderPayDetailExport({
        payPassagewayCode,
        aspOrderList: aspOrderIdList,
        downLoadType: downLoadType.value
      });

      done();
    }
  });
};
/**
 * 批量下载回单
 * @param downloadType
 * @param downloadList
 */
export const batchDownLoadReceipt: ({
  downloadType,
  downloadList,
  queryParam
}: {
  downloadType: number;
  downloadList?: any[];
  queryParam?: string;
}) => Promise<void> = async ({ downloadType, downloadList, queryParam }) => {
  const fileName = `电子回单_${formatter.date(Date.now(), 'YYYYMMDD')}`;
  await batchDownloadReceipt({
    fileName: decodeURIComponent(fileName),
    downloadType,
    downloadList,
    queryParam
  });
};

/**
 * 批量下载回单供应商
 * @param receiptUrl
 */
export const batchDownLoadReceiptBySupplier = async ({
  downloadType,
  downloadList
}) => {
  const fileName = `电子回单_${formatter.date(Date.now(), 'YYYYMMDD')}`;
  await supplierBatchDownload({
    fileName: decodeURIComponent(fileName),
    downloadType,
    downloadList
  });
};

/**
 * 单条下载支付详情供应商订单
 * @param payPassagewayCode  支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
 * @param aspOrderIdList  项目服务费订单ID集合
 */
export const downLoadOrderPayDetailSupplier = async ({
  payPassagewayCode,
  supplierOrderIdList
}) => {
  await orderPayDetailExportSupplier({
    payPassagewayCode,
    supplierOrderIdList
  });
};

/**
 * 批量下载支付详情供应商
 * @param payPassagewayCode  支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
 * @param supplierOrderList  项目服务费订单ID集合
 */
export const batchDownLoadOrderPayDetailSupplier = async ({
  payPassagewayCode,
  supplierOrderList
}) => {
  await batchOrderPayDetailExportSupplier({
    payPassagewayCode,
    supplierOrderList
  });
};
